/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ProfessionalSyncStatus = {
  type: 'Enum',
} as const;
